import React, { useEffect, useState } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import axios from "axios";
import $ from "jquery";
import AssetsView from "../../components/Modals/AssetsView";
import RaiseIssue from "../../components/Modals/RaiseIssue";
import useSmartBack from "../../hooks/useSmartBack";

function Employeedetails() {
  const { id } = useParams(); // Get the employee ID from the URL
  const handleBack = useSmartBack("/employeeinfo/list");
  const [uData, setEmployee] = useState(null);
  const getAssetImage = (type) => {
    switch (type?.toLowerCase()) {
      case "laptop":
        return "https://smarthr.dreamstechnologies.com/html/template/assets/img/products/product-05.jpg";
      case "mobile":
        return "https://i.postimg.cc/zGWv1n4R/iphone-11-PINE.jpg";
      case "phone":
        return "https://yourcdn.com/images/phone.png";
      default:
        return "https://yourcdn.com/images/default.png";
      case "desktop":
        return "https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.istockphoto.com%2Fphotos%2Fcomputer-tower&psig=AOvVaw15_m6dfIusRWd6b-Mzl7BE&ust=1752650617745000&source=images&cd=vfe&opi=89978449&ved=0CBIQjRxqFwoTCODIgciqvo4DFQAAAAAdAAAAABAE";
    }
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [assetId, setAssetId] = useState(null);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        setGlobalLoading?.(true);
        const response = await axios.get(
          `${API_BASE_URL}/employeeinfos/employeedetails/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log("RESPONSE FROM BACKEND:", response.data);
        setEmployee(response.data); // Set the employee data
      } catch (error) {
        console.error("Error fetching employee details:", error);
      } finally {
        setGlobalLoading?.(false);
      }
    };

    fetchEmployeeDetails();
  }, [id, API_BASE_URL]);

  if (!uData) {
    console.log("Employee data is still loading...");
    return <p>Loading employee details for ID: {id}</p>;
  }
  const serialNos = uData.assets?.map((asset) => asset.serial_no) || [];

  const showmodal = (id) => {
    setAssetId(id);
    const modal = new window.bootstrap.Modal($("#asset_info"));
    modal.show();
  };
  const showRaiseIssueModal = (id) => {
    setAssetId(id); // sets the asset_id for the issue form
    const modal = new window.bootstrap.Modal($("#refuse_msg"));
    modal.show();
  };

  return (
    <div className="content">
      <div className="row align-items-center mb-4">
        <div className="col-sm-6">
          <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
            {/* <a href="companies-grid.html">
              <i className="ti ti-arrow-left me-2"></i>Companies
            </a>
            <span className="text-gray d-inline-flex ms-2">
              / BrightWave Innovations
            </span> */}
            <p>
              <a
                href="/employeeinfo/list"
                onClick={(event) => {
                  event.preventDefault();
                  handleBack();
                }}
                className="text-gray d-inline-flex ms-2"
              >
                ← Back to employee List
              </a>
            </p>
          </h6>
        </div>
        <div className="col-sm-6">
          <div className="d-flex align-items-center justify-content-sm-end">
            {/* <a
              href="javascript:void(0);"
              className="btn btn-primary d-inline-flex align-items-center me-2"
              data-bs-toggle="modal"
              data-bs-target="#add_deals"
            >
              <i className="ti ti-circle-plus me-2"></i>Add Deal
            </a> */}
            {/* <a
              href="javascript:void(0);"
              className="btn btn-dark d-inline-flex align-items-center"
            >
              <i className="ti ti-mail me-2"></i>Send Email
            </a> */}
            <div className="head-icons ms-2 mb-0">
              {/* <a
                href="javascript:void(0);"
                className=""
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-original-title="Collapse"
                id="collapse-header"
              >
                <i className="ti ti-chevrons-up"></i>
              </a> */}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4 theiaStickySidebar">
          <div className="card card-bg-1">
            <div className="card-body p-0">
              <span
                className="avatar avatar-xl border bg-white rounded-circle m-auto d-flex mb-2"
                style={{
                  width: "100px", // ✅ Adjust size here
                  height: "100px", // ✅ Same height to keep it a circle
                  overflow: "hidden", // ✅ Crop overflow
                }}
              >
                <img
                  src={
                    uData.userpic
                      ? `https://pinepositivemoves.com/files/media/${uData.userpic}`
                      : "default-profile.png"
                  }
                  alt="Profile"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // ✅ Ensures proper fit without distortion
                  }}
                />
              </span>
              <div className="text-center px-3 pb-3 border-bottom">
                <h5 className="d-flex align-items-center justify-content-center mb-1">
                  {uData.firstname} {uData.lastname}
                  <i
                    className={` ${
                      uData.status === "inactive"
                        ? "fa-solid fa-xmark ms-1 text-danger"
                        : "ti ti-discount-check-filled ms-1 text-success"
                    }`}
                  ></i>
                </h5>
                <p className="text-dark">
                  {uData.Designation} <br />
                  {uData.Department}
                </p>
              </div>
              <div className="p-3 border-bottom">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h6>Basic information</h6>
                  <a
                    href="javascript:void(0);"
                    className="btn btn-icon btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_company"
                  >
                    {/* <i className="ti ti-edit"></i> */}
                  </a>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-id me-2"></i>
                    Emp_id
                  </span>
                  <p className="text-dark">{uData.id || "Not available"}</p>
                </div>

                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-phone me-2"></i>
                    Phone
                  </span>
                  <p className="text-dark">{uData.Phone || "Not available"}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-mail-check me-2"></i>
                    Email
                  </span>

                  {/* <a href="javascript:void(0);" className="text-info d-inline-flex align-items-center">darlee@example.com <i className="ti ti-copy text-dark ms-2"></i></a> */}
                  <a href={`mailto:${uData.Email}`}>{uData.Email}</a>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-gender-male me-2"></i>
                    Joined On
                  </span>
                  <p className="text-dark">
                    {" "}
                    {uData.appointment_date || "Not available"}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-e-passport me-2"></i>
                    Reporting to
                  </span>
                  <div className="text-dark text-end">
                    {uData.reportingfirst_1 || uData.reportinglast_1 ? (
                      <p className="mb-0">
                        {uData.reportingfirst_1 || "Not available"}{" "}
                        {uData.reportinglast_1 || ""}
                      </p>
                    ) : (
                      <p className="mb-0">Not available</p>
                    )}
                    {uData.reportingfirst_2 || uData.reportinglast_2 ? (
                      <p className="mb-0">
                        {uData.reportingfirst_2 || "Not available"}{" "}
                        {uData.reportinglast_2 || ""}
                      </p>
                    ) : null}
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-user-check me-2"></i>
                    Buddy
                  </span>
                  <p className="text-dark">
                    {uData.buddyfirst || "Not available"} {uData.buddylast}
                  </p>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <span className="d-inline-flex align-items-center">
                    <i className="ti ti-clock-hour-10 me-2"></i>
                    PMoves Exp.
                  </span>
                  <p className="text-dark"> {uData.total_experience}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-8">
          <div>
            <div className="tab-content custom-accordion-items">
              <div
                className="tab-pane active show"
                id="bottom-justified-tab1"
                role="tabpanel"
              >
                <div
                  className="accordion accordions-items-seperate"
                  id="accordionExample"
                >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="accordion-item">
                        <div className="row">
                          <div className="accordion-header" id="headingTen">
                            <div className="accordion-button">
                              <div className="d-flex align-items-center justify-content-between flex-fill">
                                <h5>Personal Details</h5>
                                <div className="d-flex">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit_details"
                                  >
                                    {/* <i className="ti ti-edit"></i> */}
                                  </a>
                                  <a
                                    href="#"
                                    className="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderTenn"
                                    aria-expanded="true"
                                    aria-controls="primaryBorderTenn"
                                  >
                                    <i className="ti ti-chevron-down fs-18"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderTenn"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingTen"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        DOB
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.date_of_birth || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Cambridge University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Gender
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.gender || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Personal Email
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.personal_email || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Blood group
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.blood_group || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Wedding Anniversary
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.wedding_anniversary ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Pan card
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.pan_card || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Aadhaar Card
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.aadhaar_no || "Not available"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="accordion-item">
                        <div className="row">
                          <div className="accordion-header" id="headingEleven">
                            <div className="accordion-button collapsed">
                              <div className="d-flex align-items-center justify-content-between flex-fill">
                                <h5>Emergency contact</h5>
                                <div className="d-flex">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit_emergency"
                                  >
                                    {/* <i className="ti ti-edit"></i> */}
                                  </a>
                                  <a
                                    href="#"
                                    className="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderElevenn"
                                    aria-expanded="true"
                                    aria-controls="primaryBorderElevenn"
                                  >
                                    <i className="ti ti-chevron-down fs-18"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderElevenn"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingEleven"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Relation
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.relation || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        contact name
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.emergency_contact_name ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      {/* <span className="d-inline-flex align-items-center fw-normal">
                                        Oxford University
                                      </span> */}
                                      <h6 className="d-flex align-items-center mt-1">
                                        Emergency contact
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.emergency_contact ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <div className="accordion-header" id="headingTwo">
                      <div className="accordion-button">
                        <div className="d-flex align-items-center flex-fill">
                          <h5>Bank Information</h5>
                          <a
                            href="#"
                            className="btn btn-sm btn-icon ms-auto"
                            data-bs-toggle="modal"
                            data-bs-target="#edit_bank"
                          >
                            {/* <i className="ti ti-edit"></i> */}
                          </a>
                          <a
                            href="#"
                            className="d-flex align-items-center collapsed collapse-arrow"
                            data-bs-toggle="collapse"
                            data-bs-target="#primaryBorderTwo"
                            aria-expanded="false"
                            aria-controls="primaryBorderTwo"
                          >
                            <i className="ti ti-chevron-down fs-18"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderTwo"
                      className="accordion-collapse collapse border-top"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="row">
                          <div className="col-md-3">
                            <span className="d-inline-flex align-items-center">
                              Bank Name
                            </span>
                            <h6 className="d-flex align-items-center fw-medium mt-1">
                              {uData.bank_name || "Not available"}
                            </h6>
                          </div>
                          <div className="col-md-3">
                            <span className="d-inline-flex align-items-center">
                              Bank account no
                            </span>
                            <h6 className="d-flex align-items-center fw-medium mt-1">
                              {uData.bank_number || "Not available"}
                            </h6>
                          </div>
                          <div className="col-md-3">
                            <span className="d-inline-flex align-items-center">
                              IFSC Code
                            </span>
                            <h6 className="d-flex align-items-center fw-medium mt-1">
                              {uData.bank_ifsc || "Not available"}
                            </h6>
                          </div>
                          <div className="col-md-3">
                            <span className="d-inline-flex align-items-center">
                              Branch
                            </span>
                            <h6 className="d-flex align-items-center fw-medium mt-1">
                              {uData.bank_branch || "Not available"}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingThree">
                      <div className="accordion-button">
                        <div className="d-flex align-items-center justify-content-between flex-fill">
                          <h5>Linkedin</h5>
                          <div className="d-flex">
                            <a
                              href="#"
                              className="btn btn-icon btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target="#edit_familyinformation"
                            >
                              {/* <i className="ti ti-edit"></i> */}
                            </a>
                            <a
                              href="#"
                              className="d-flex align-items-center collapsed collapse-arrow"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderThree"
                              aria-expanded="false"
                              aria-controls="primaryBorderThree"
                            >
                              <i className="ti ti-chevron-down fs-18"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderThree"
                      className="accordion-collapse collapse border-top"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <tbody>
                              <tr>
                                <td>
                                  <strong>Username</strong>
                                </td>
                                <td>{uData.Login_id || "Not available"}</td>
                                <td>
                                  <strong>Password</strong>
                                </td>
                                <td className="password">
                                  {uData.password ? "*****" : "Not available"}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Premium</strong>
                                </td>
                                <td>{uData.upgraded || "Not available"}</td>
                                <td>
                                  <strong>Linkedin URL</strong>
                                </td>
                                <td>
                                  {uData.linkedin_url ? (
                                    <>
                                      <button
                                        onClick={() =>
                                          window.open(
                                            uData.linkedin_url,
                                            "_blank"
                                          )
                                        }
                                        className="btn btn-sm btn-primary me-2"
                                        type="button"
                                      >
                                        View
                                      </button>
                                      <button
                                        onClick={() => {
                                          navigator.clipboard.writeText(
                                            uData.linkedin_url
                                          );
                                        }}
                                        className="btn btn-sm btn-secondary"
                                        type="button"
                                      >
                                        Copy
                                      </button>
                                    </>
                                  ) : (
                                    "Not available"
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="accordion-item">
                        <div className="row">
                          <div className="accordion-header" id="headingFour">
                            <div className="accordion-button">
                              <div className="d-flex align-items-center justify-content-between flex-fill">
                                <h5>Medical Insurance</h5>
                                <div className="d-flex">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit_education"
                                  >
                                    {/* <i className="ti ti-edit"></i> */}
                                  </a>
                                  <a
                                    href="#"
                                    className="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderFour"
                                    aria-expanded="false"
                                    aria-controls="primaryBorderFour"
                                  >
                                    <i className="ti ti-chevron-down fs-18"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderFour"
                            className="accordion-collapse collapse border-top"
                            aria-labelledby="headingFour"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <h6 className="d-flex align-items-center mt-1">
                                        Policy Number
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {" "}
                                      {uData.insurance_policy_number ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <h6 className="d-flex align-items-center mt-1">
                                        UHID
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.insurance_uhid_one ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <h6 className="d-flex align-items-center mt-1">
                                        Name
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.firstname} {uData.lastname}
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <h6 className="d-flex align-items-center mt-1">
                                        Expiry Date
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.insurance_expiry_date ||
                                        "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="accordion-item">
                        <div className="row">
                          <div className="accordion-header" id="headingFive">
                            <div className="accordion-button collapsed">
                              <div className="d-flex align-items-center justify-content-between flex-fill">
                                <h5>Passport</h5>
                                <div className="d-flex">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit_experience"
                                  >
                                    {/* <i className="ti ti-edit"></i> */}
                                  </a>
                                  <a
                                    href="#"
                                    className="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderFive"
                                    aria-expanded="false"
                                    aria-controls="primaryBorderFive"
                                  >
                                    <i className="ti ti-chevron-down fs-18"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="primaryBorderFive"
                            className="accordion-collapse collapse border-top"
                            aria-labelledby="headingFive"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <h6 className="d-inline-flex align-items-center fw-medium">
                                        Passport
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {" "}
                                      {uData.passport_no || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <h6 className="d-inline-flex align-items-center fw-medium">
                                        Issue Place
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.issue_place || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <h6 className="d-inline-flex align-items-center fw-medium">
                                        Date of issue
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.issue_date || "Not available"}
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                      <h6 className="d-inline-flex align-items-center fw-medium">
                                        Expiry date
                                      </h6>
                                    </div>
                                    <p className="text-dark">
                                      {uData.expiry_date || "Not available"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row">
            <div className="card">
              <div className="card-body">
                <div className="contact-grids-tab p-0 mb-3">
                  <ul className="nav nav-underline" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="info-tab2"
                        data-bs-toggle="tab"
                        data-bs-target="#basic-info2"
                        type="button"
                        role="tab"
                        aria-selected="true"
                      >
                        Company Assets
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="address-tab2"
                        data-bs-toggle="tab"
                        data-bs-target="#address2"
                        type="button"
                        role="tab"
                        aria-selected="false"
                      >
                        Media
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="address-tab2"
                        data-bs-toggle="tab"
                        data-bs-target="#timeline"
                        type="button"
                        role="tab"
                        aria-selected="false"
                      >
                        Employee Timeline
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="tab-content" id="myTabContent3">
                  <div
                    className="tab-pane fade show active"
                    id="basic-info2"
                    role="tabpanel"
                    aria-labelledby="info-tab2"
                    tabindex="0"
                  >
                    <div className="row">
                      <div className="col-md-12 mt-3 table-responsive">
                        {uData.assets && uData.assets.length > 0 ? (
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Asset Id</th>
                                <th>Image</th>

                                <th>Make</th>
                                <th>Model No</th>
                                <th>Configuration</th>

                                <th>Status</th>
                                <th>Raise Issue</th>
                              </tr>
                            </thead>
                            <tbody>
                              {uData.assets.map((asset, index) => (
                                <tr key={index}>
                                  <td>{asset.id || "N/A"}</td>
                                  <td>
                                    <div className="col-md-8">
                                      <div className="d-flex align-items-center">
                                        <a
                                          href="project-details.html"
                                          className="flex-shrink-0 me-2"
                                        >
                                          <img
                                            src={getAssetImage(
                                              asset.assets_type
                                            )}
                                            className="img-fluid rounded-circle"
                                            alt={
                                              asset.assets_type || "Asset image"
                                            }
                                            style={{
                                              width: "40px",
                                              height: "40px",
                                              objectFit: "contain",
                                              backgroundColor: "#f5f5f5", // optional for white backgrounds
                                            }}
                                          />
                                        </a>
                                        <div>
                                          <h6 className="mb-1">
                                            <a href="project-details.html">
                                              {"#"}{" "}
                                              {asset.serial_no ||
                                                "Not available"}
                                            </a>
                                          </h6>
                                          <div className="d-flex align-items-center">
                                            <p>
                                              <span className="text-primary">
                                                {asset.assets_type ||
                                                  "Not available"}
                                                <i className="ti ti-point-filled text-success mx-1"></i>
                                              </span>
                                              Assigned on{" "}
                                              {asset.from || "Not available"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>{" "}
                                  </td>

                                  <td>{asset.make || "N/A"}</td>
                                  <td>{asset.model_number || "N/A"}</td>
                                  <td>{asset.configuration || "N/A"}</td>

                                  <td>
                                    {asset.to ? (
                                      asset.to
                                    ) : (
                                      <span className="text-success">
                                        Active
                                      </span>
                                    )}
                                  </td>
                                  {/* <td>
                                    <div className="col-md-1">
                                      <div className="dropdown ms-2">
                                        <a
                                          href="javascript:void(0);"
                                          className="d-inline-flex align-items-center"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <i className="ti ti-eye"></i>
                                        </a>
                                        <ul className="dropdown-menu dropdown-menu-end p-3">
                                          <li>
                                            <a
                                              href="javascript:void(0);"
                                              className="dropdown-item rounded-1"
                                              onClick={(e) =>
                                                showmodal(asset.id)
                                              }
                                            >
                                              View Info
                                            </a>
                                          </li>
                                          <li>
                                            <a
                                              href="javascript:void(0);"
                                              className="dropdown-item rounded-1"
                                              onClick={() =>
                                                showRaiseIssueModal(asset.id)
                                              }
                                            >
                                              Raise Issue
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </td> */}
                                  <td>
                                    <a
                                      href="javascript:void(0);"
                                      onClick={() =>
                                        showRaiseIssueModal(asset.id)
                                      }
                                      className="text-primary"
                                      title="Raise Issue"
                                    >
                                      <i className="ti ti-alert-circle fs-3"></i>
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p>No assets available.</p>
                        )}
                        <AssetsView asset_id={assetId} />
                        <RaiseIssue asset_id={assetId} />
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane"
                    id="timeline"
                    role="tabpanel"
                    aria-labelledby="info-tab2"
                    tabindex="0"
                  >
                    <div className="row">
                      <div className="col-md-12 mt-3 table-responsive">
                        {uData.designationchanges &&
                        uData.designationchanges.length > 0 ? (
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Subject</th>
                                <th>Created on</th>
                              </tr>
                            </thead>
                            <tbody>
                              {uData.designationchanges.map(
                                (designationchange, index) => (
                                  <tr key={index}>
                                    <td>
                                      {index ===
                                      uData.designationchanges.length - 1
                                        ? "Joined as: "
                                        : " Designation Changed to: "}
                                      {designationchange.Designation || "N/A"}
                                    </td>
                                    <td>
                                      {designationchange.change_date || "N/A"}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        ) : (
                          <p>No Timeline available.</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane"
                    id="address2"
                    role="tabpanel"
                    aria-labelledby="info-tab2"
                    tabindex="0"
                  >
                    <div className="row">
                      <div className="col-md-12 mt-3 table-responsive">
                        {uData.files && uData.files.length > 0 ? (
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Document Type</th>
                                <th>Date</th>
                                <th>Filename</th>
                                <th>Download</th>
                                {/*<th>From</th>
                                  <th>Status</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {uData.files.map((file, index) => (
                                <tr key={index}>
                                  <td>{file.Document || "N/A"}</td>
                                  <td>{file.Filetypename || "N/A"}</td>
                                  <td>{file.Date || "N/A"}</td>
                                  <td>{file.filename || "N/A"}</td>

                                  {/* <td>
                                    
                                   

                                    {file.filename && (
                                      <a
                                        href={`https://pinepositivemoves.com/employeeinfos/download/${file.id}`}
                                        download
                                        className="btn btn-sm btn-outline-secondary ms-2"
                                        title="Download File"
                                      >
                                        <i className="ti ti-download"></i>
                                      </a>
                                    )}
                                  </td> */}
                                  <td>
                                    {[401, 10, 210, 493, 42].includes(
                                      file.employeeinfo_id
                                    ) && file.filename ? (
                                      <a
                                        href={`https://pinepositivemoves.com/employeeinfos/download/${file.id}`}
                                        download
                                        className="btn btn-sm btn-outline-secondary ms-2"
                                        title="Download File"
                                      >
                                        <i className="ti ti-download"></i>
                                      </a>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>

                                  {/*<td>{asset.configuration || "N/A"}</td>
                                    <td>{asset.from || "N/A"}</td>
                                    <td>{asset.to || "Active"}</td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p>No Media available.</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="assets"
                    role="tabpanel"
                    aria-labelledby="address-tab2"
                    tabindex="0"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Employeedetails;
